import { useContext } from "react";
import styles from "../Import/ImportModal.module.css";
import SheetProduct from "../../../assets/sheet_product.png";
import { TemplateContext } from "../../../context/TemplateContext";

function Modal({ closeModal }) {
  const { selectedTemplate } = useContext(TemplateContext);
  if (!selectedTemplate) {
    return (
      <div className={styles.modalBackground}>
        <div className={styles.modalContainer}>
          <div className={styles.content}>
            <h2>Nenhum template selecionado</h2>
          </div>
          <div className={styles.buttonContent}>
            <button onClick={closeModal} className={styles.buttonCancel}>
              Fechar
            </button>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.content}>
          <h2>Importação de Produtos</h2>

          <h4>Exemplo</h4>

          <div className={styles.inputsRow}>
            <div className={styles.inputGroup}>
              <label htmlFor="barcode">Código de Barras</label>
              <input id="barcode" type="text" placeholder="A" disabled />
            </div>
            <div className={styles.inputGroup}>
              <label htmlFor="productName">Nome do Produto</label>
              <input id="productName" type="text" placeholder="B" disabled />
            </div>
            <div className={styles.inputGroup}>
              <label htmlFor="manufacturer">Fabricante</label>
              <input id="manufacturer" type="text" placeholder="C" disabled />
            </div>
            <div className={styles.inputGroup}>
              <label htmlFor="group">Grupo</label>
              <input id="group" type="text" placeholder="D" disabled />
            </div>
            <div className={styles.inputGroup}>
              <label htmlFor="line">Linha</label>
              <input id="line" type="text" placeholder="1" disabled />
            </div>
          </div>

          <img src={SheetProduct} alt="Exemplo de planilha de importação" />

          <h4>Nome do Template</h4>
          <input
            className={styles.inputTemplateName}
            type="text"
            value={selectedTemplate.templateName}
            disabled
          />

          <h4>Parâmetros</h4>
          <table className={styles.parametersTable}>
            <thead>
              <tr>
                <th>Código de Barras</th>
                <th>Nome do Produto</th>
                <th>Fabricante</th>
                <th>Grupo</th>
                <th>Linha</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <input
                    type="text"
                    placeholder="Coluna (ex: A)"
                    value={selectedTemplate.barcode}
                    disabled
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Coluna (ex: B)"
                    value={selectedTemplate.productName}
                    disabled
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Coluna (ex: C)"
                    value={selectedTemplate.manufacturer}
                    disabled
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Coluna (ex: D)"
                    value={selectedTemplate.group}
                    disabled
                  />
                </td>
                <td>
                  <input
                    type="number"
                    placeholder="Linha Inicial (ex: 1)"
                    value={selectedTemplate.line}
                    disabled
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className={styles.buttonContent}>
          <button onClick={closeModal} className={styles.buttonCancel}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}

export default Modal;
